import React from 'react';
import Store from '../../../redux/store';
import { get, getConfig } from '../../../helpers';
import { getDefaultformFields, submitToMarketo } from '../utilities/form-utilities';

const RequestTrialForm = React.lazy(() => import('../index' /* webpackChunkName: "request-a-trial-form" */));

function getMarketoAPIVariant(variant: string): string {
    return getConfig(`components.request-a-trial.marketoAPIVariant.${variant}`, 'DatasetRAT') as string;
}

function getDefaultSubmissionBody(
    data: RequestATrialState
) {
    const ratAPIRequest: RATRequest = {
        cInterestOther: data.OtherInterest,
        cInterestOtherLive: data.OtherInterest,
        city: data.City,
        company: data.Company,
        companyType1c: data.CompanyType as string,
        complianceCountry: data.Country as string,
        email: data.Email,
        firstName: data.FirstName,
        gDPRConsentQuestion: String(data.HasUserConsent),
        jobFunction1c: data.JobFunction as string,
        lastName: data.LastName,
        phone: data.Phone,
        spProductServiceInterestDetailsc: data.OtherInterest,
        spProductServiceInterestsc: data.InterestArea,
        state: data.State ? String(data.State) : ''
    } as RATRequest;
    if (data.MasterTrialAgreement) {
        ratAPIRequest.masterTrialAgreementActionMostRecent = data.MasterTrialAgreement;
        ratAPIRequest.masterTrialAgreementActionTimeStampMostRecent = new Date().toJSON();
    }
    return ratAPIRequest;
}

function RequestTrialDefault(props: RequestATrialFormProps) {
    const { productName = '', marketMSADataLink, dataFilePath, marketplaceMSATooltip, productVariant, variant, titleText, keyPageIdPageText, ratVariant } = props;
    const onSubmit = (
        data: RequestATrialState,
        cb: () => void,
        error: (error: string) => void
    ) => {
        const utmParameters: UTMParameters = get(Store.getState(), 'shared.utmParameters', {});
        const kenshotext = data.InterestArea ? 'Kensho; ' : 'Kensho';
        let notapplicableText = data.InterestArea ? '' : 'Data Management Solutions';
        if (productVariant === 'solution') notapplicableText = productName;
        data.InterestArea = `${variant === 'kensho' ? kenshotext : notapplicableText}${data.InterestArea || ''}`;
        data.OtherInterest = productName ? `${productName} : ${data.OtherInterest}` : data.OtherInterest;
        data.InterestArea = data.InterestArea
            ? data.InterestArea.replace(/,/g, ';')
            : '';
        let requestBody = getDefaultSubmissionBody(data);
        requestBody = {
            ...requestBody,
            utmSource: utmParameters.utmSource,
            utmMedium: utmParameters.utmMedium,
            utmCampaign: utmParameters.utmCampaign,
            utmTerm: utmParameters.utmTerm,
            utmContent: utmParameters.utmContent,
            variant: getMarketoAPIVariant(variant || '')
        };
        submitToMarketo(requestBody, cb, error);
    };
    return (
        <RequestTrialForm onSubmitForm={onSubmit} formTextFields={getDefaultformFields()} productVariant={productVariant} keyPageIdPageText={keyPageIdPageText} titleText={titleText} marketMSADataLink={marketMSADataLink} dataFilePath={dataFilePath} marketplaceMSATooltip={marketplaceMSATooltip} productName={productName} headerVariant={variant} ratVariant={ratVariant} />
    );
}

export default React.memo(RequestTrialDefault);
